import React from "react";
import ReactModal from "react-modal";
import "./OurTeamModal.scss";

interface OurTeamModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const OurTeamModal: React.FC<OurTeamModalProps> = ({ isOpen, onClose }) => {
  const isMobile = window.innerWidth <= 768;

  const customModalStyles: any = {
    content: {
      top: isMobile ? "0" : "50%",
      left: isMobile ? "0" : "50%",
      right: "auto",
      bottom: "auto",
      transform: isMobile ? "none" : "translate(-50%, -50%)",
      width: isMobile ? "100%" : "100%",
      maxWidth: isMobile ? "100%" : "650px",
      height: "auto",
      maxHeight: isMobile ? "600px" : "700px",
      overflowY: "auto",
      padding: "20px",
      borderRadius: isMobile ? "0" : "12px",
      display: "block",
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      contentLabel="Our Team"
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
    >
      <div className="our-team-modal">
        <div className="modal-header">
          <h2 className="modal-title">Our Team</h2>
          <button className="close-button" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="modal-content">
          <div className="our-team-content">
            <p>Team information will be displayed here.</p>
            {/* Add your Our Team content here */}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default OurTeamModal;